import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './ObfuscatedEmail.css';

/** Split so the full address is not a single literal in the HTML source. */
function buildAddress() {
  const local = ['axe', 'lesha'].join('');
  const host = ['gma', 'il.com'].join('');
  return `${local}@${host}`;
}

function displayLabel() {
  const local = ['axe', 'lesha'].join('');
  const host = ['gma', 'il'].join('');
  const tld = ['com'].join('');
  return `${local} [at] ${host} [dot] ${tld}`;
}

export default function ObfuscatedEmail({ className = '' }) {
  const { t } = useTranslation();

  const openMail = (event) => {
    event.preventDefault();
    window.location.href = `mailto:${buildAddress()}`;
  };

  return (
    <button
      type="button"
      className={`obfuscated-email ${className}`.trim()}
      onClick={openMail}
      title={t('legal.contactEmailHint')}
    >
      {displayLabel()}
    </button>
  );
}

ObfuscatedEmail.propTypes = {
  className: PropTypes.string,
};
